module.exports = __webpack_public_path__ + "static/media/S (5).d96793aa.jpg";